import React from 'react';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import {
  DetailsCard,
  DetailsCardBody,
  DetailsCardHeader,
  DetailsCardFooter,
  Skeleton,
  Flex,
} from '@tq/ui-components';
import { useTranslation } from 'react-i18next';

export const ConsultationCardSkeleton: React.FC = () => {
  const { t } = useTranslation('consultation_card');

  return (
    <DetailsCard aria-label={t('consultation_loading', 'Consultation loading')} mb={4}>
      <DetailsCardHeader>
        <Flex width='100%' mt={1}>
          <Skeleton
            // Cannot use spacing units on this for some reason
            h='22.25px'
            w='20px'
            borderRadius={5}
          />
          <Skeleton ml={5} width='50%' borderRadius={5} />
          <Skeleton justifySelf='flex-end' ml='auto' width='10%' borderRadius={5} />
          <Skeleton ml={4} width='3%' borderRadius={5} />
        </Flex>
      </DetailsCardHeader>
      <DetailsCardBody>
        <Flex ml={10}>
          <Skeleton width='40%' height={4} borderRadius={5} />
          <Skeleton width='25%' ml={20} height={4} borderRadius={5} />
          <Skeleton justifySelf='flex-end' width='14%' ml='auto' height={4} borderRadius={5} />
        </Flex>
        <Flex mt={3} ml={10}>
          <Skeleton width='20%' height={4} borderRadius={5} />
          <Skeleton ml='auto' justifySelf='end' width='14%' height={4} borderRadius={5} />
        </Flex>
      </DetailsCardBody>
      <DetailsCardFooter background={COLOURS.gray[200]} />
    </DetailsCard>
  );
};
